module.exports = __webpack_public_path__ + "img/Flag_of_Venezuela.092be0d1.svg";